import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconShipped: FC<IconProps> = props => (
    <SVG
        {...props}
        paths={[
            'M0 56.888889h739.555556v682.666667H0V56.888889z m85.333333 85.333333v512h568.888889v-512h-568.888889z',
            'M654.222222 284.444444H853.333333l170.666667 170.666667v284.444445h-369.777778V284.444444z m85.333334 369.777778h199.111111V490.439111L818.005333 369.777778H739.555556v284.444444zM369.777778 824.888889a142.222222 142.222222 0 1 1-284.444445 0 142.222222 142.222222 0 0 1 284.444445 0z m-85.333334 0q0-23.552-16.668444-40.220445T227.555556 768q-23.552 0-40.220445 16.668444T170.666667 824.888889q0 23.552 16.668444 40.220444T227.555556 881.777778q23.552 0 40.220444-16.668445T284.444444 824.888889z',
            'M938.666667 824.888889a142.222222 142.222222 0 1 1-284.444445 0 142.222222 142.222222 0 0 1 284.444445 0z m-85.333334 0q0-23.552-16.668444-40.220445T796.444444 768q-23.552 0-40.220444 16.668444T739.555556 824.888889q0 23.552 16.668444 40.220444T796.444444 881.777778q23.552 0 40.220445-16.668445T853.333333 824.888889z'
        ]}
    />
);